__turbopack_context__.v({
  "form-actions": "ReviewForm-module-scss-module__r8p1QW__form-actions",
  "form-comment": "ReviewForm-module-scss-module__r8p1QW__form-comment",
  "form-counter": "ReviewForm-module-scss-module__r8p1QW__form-counter",
  "form-email": "ReviewForm-module-scss-module__r8p1QW__form-email",
  "form-error": "ReviewForm-module-scss-module__r8p1QW__form-error",
  "form-error-stars": "ReviewForm-module-scss-module__r8p1QW__form-error-stars",
  "form-rating-container": "ReviewForm-module-scss-module__r8p1QW__form-rating-container",
  "success-container": "ReviewForm-module-scss-module__r8p1QW__success-container",
  "success-info": "ReviewForm-module-scss-module__r8p1QW__success-info",
});
